
import React from 'react';
import { Button } from "@/components/ui/button";
import { useLanguage } from '@/contexts/LanguageContext';
import { useIsMobile } from '@/hooks/use-mobile';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const isMobile = useIsMobile();
  
  return (
    <div className="flex items-center">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage(language === 'en' ? 'es' : 'en')}
        className={`flex items-center justify-center rounded-full hover:bg-white/10 ${isMobile ? 'w-8 h-8 p-0' : 'w-10 h-10'}`}
        aria-label={`Switch to ${language === 'en' ? 'Spanish' : 'English'}`}
      >
        <span className={`font-medium text-sm flex items-center justify-center rounded-full aspect-square bg-blue-500/20 border-2 border-blue-500/30 shadow-sm ${isMobile ? 'w-7 h-7' : 'w-8 h-8'}`}>
          {language === 'en' ? 'ES' : 'EN'}
        </span>
      </Button>
    </div>
  );
};

export default LanguageToggle;
